


export function BreakfastFood () {
    return (
<main className="project-page">
    <header className="project-page-intro">
        <p className="project-page-kicker">I have the toes that I have</p>
        <h1>Breakfast Food</h1>
    </header>
    <div className="row justify-content-center">
        <img width="100%" className="col-11" src="../../../images/projects/breakfast-food/tim.jpg" loading="lazy" />
    </div>
    <div className="row justify-content-center">
        <img src="../../../images/projects/breakfast-food/cup-and-chair.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/empty-seat.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/ketchup-table.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/corner-seat.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/sauce-table.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/wales-cafe.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/coffees.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/post-breakfast.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/newcastle-carpet.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/ketchup-grab.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/salt-and-ketchup.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/ritz-carpet.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/flat-white.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
        <img src="../../../images/projects/breakfast-food/blue-chair.jpg" className="col-11 col-lg-3 mt-5"   width="100%" loading="lazy" />
    </div> 
</main>
    )}
